import moment from 'moment';
import AccountHeading from './AccountHeading';
import AccountProfileCard from "./Accounts/AccountProfileCard";
import PlanDetailCard from "./Accounts/PlanDetailCard";
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';

const profileIcon = <FontAwesomeIcon type={'solid'} icon={'user'} iconClass={'fa-duotone icon-gradient fs-1'} />;

const keyIcon =  <FontAwesomeIcon type={'solid'} icon={'key'} iconClass={'fa-duotone icon-gradient fs-1'} />;

const AccountInfo = ({ userInfo }) => {
  const dateSince = moment(userInfo.AccountProfile[0].MemberSince).format('Do MMM YYYY');

  return (
    <div>
      <AccountHeading title={'Account Profile'} />
      <div className="row">
        <AccountProfileCard
          title={"Member Since"}
          icon={profileIcon}
          description={dateSince}
        />
        <AccountProfileCard
          title={"User Key"}
          icon={keyIcon}
          description={userInfo.AccountProfile[0].UserKey}
        />
      </div>

      <AccountHeading title={'Plan Details'} />
      <div className="row">
        {userInfo && userInfo.PlanDetails && userInfo.PlanDetails.map((i) => (
          <PlanDetailCard planDetail={i} />
        ))}
      </div>
    </div>
  );
};

export default AccountInfo;
